/* __next_internal_client_entry_do_not_use__ Option auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { Typography } from "@faire/web--source/slate/Typography";
import React, { useCallback } from "react";
import styled from "styled-components";
import { Link } from "../LinkAnchor";
var LinkText = styled.span.withConfig({
    componentId: "sc-6d17519d-0"
})([
    "&:hover{border-bottom:1px solid ",
    ";}"
], Core.border.default);
export var Option = function(param) {
    var optionData = param.optionData, index = param.index, handleOnClick = param.handleOnClick, isLastIndex = param.isLastIndex;
    var _getWindow;
    var onClick = useCallback(function() {
        return handleOnClick === null || handleOnClick === void 0 ? void 0 : handleOnClick(optionData);
    }, [
        optionData,
        handleOnClick
    ]);
    return optionData.path ? /*#__PURE__*/ _jsxs("li", {
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "https://schema.org/ListItem",
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx(Link, {
                to: optionData.path,
                itemScope: true,
                itemProp: "item",
                itemType: "https://schema.org/WebPage",
                itemID: encodeURI("".concat((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.origin).concat(optionData.path)),
                children: /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        /*#__PURE__*/ _jsx(LinkText, {
                            itemProp: "name",
                            children: optionData.label
                        }),
                        !isLastIndex ? "  /  " : ""
                    ]
                })
            }, optionData.path),
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "position",
                content: "".concat(index + 1)
            })
        ]
    }, optionData.path) : /*#__PURE__*/ _jsxs("li", {
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "https://schema.org/ListItem",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                itemProp: "name",
                children: optionData.label
            }),
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "position",
                content: "".concat(index + 1)
            })
        ]
    });
};
